export default field => String(field).trim().length > 0;
